import React from "react";
import { useTranslation } from "../../context/TranslationContext";

const SecuraPayment = () => {
  const {
    securaTitle1,
    securaTitle2,
    securaTitle3,
    securaP1Pre,
    securaP1Company,
    securaP1Post,
    securaP2,
    securaP3,
    securaPolicyTitle,
    securaPolicyText,
  } = useTranslation();
  return (
    <div className="bg-[#F0F6F8] lg:py-32 py-16">
      <div className="container">
        <div className="flex lg:flex-nowrap flex-wrap lg:items-start items-center lg:justify-start justify-center">
          <div className="lg:w-1/2 w-full flex lg:order-1 order-2 lg:items-start items-center lg:justify-start justify-center lg:text-start text-center">
            <div className="flex  flex-col lg:items-end items-center lg:justify-end justify-center w-full lg:pr-10">
              <div className="flex flex-wrap sm:justify-start justify-center sm:pl-12 mb-8">
                <span className="text-primary font-bold sm:text-[2.875rem] text-[1.875rem]">
                  {securaTitle1}
                </span>
                <div className="flex lg:flex-col lg:items-start items-center">
                  <span className="font-bold text-dark sm:text-[2.875rem] text-[1.875rem]">
                    {securaTitle2}
                  </span>
                  <span className="font-bold text-dark sm:text-[2.875rem] text-[1.875rem] leading-[2.875rem]">
                    {securaTitle3}
                  </span>
                </div>
              </div>
              <div className="flex flex-col fon-normal text-15 opacity-50 lg:text-end text-center">
                <p>
                  <strong>
                    {process.env.NEXT_PUBLIC_SITENAME} (
                    {process.env.NEXT_PUBLIC_DOMAIN} )
                  </strong>
                  {securaP1Pre}{" "}
                  <strong>{securaP1Company}</strong> {securaP1Post}
                </p>
                <p>
                  {securaP2}
                </p>
                <p>
                  {securaP3}
                </p>
                <p>
                  <strong>{securaPolicyTitle}</strong>{" "}
                  {securaPolicyText.split("{domain}").join(
                    process.env.NEXT_PUBLIC_DOMAIN
                  )}
                </p>
              </div>
            </div>
          </div>
          <div className="lg:w-1/2 w-full flex lg:items-start items-center lg:justify-start justify-center lg:order-2 order-1">
            <img
              src="/images/secure-payment.png"
              className="object-contain w-[41.563rem] sm:h-[29.313rem] h-[12.5rem]"
            ></img>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SecuraPayment;
